import React, {useEffect, useState} from "react";
import {mapPoint} from "../utils/pointMaps";
import useWindowSize from "../utils/useWindowSize";

// Интерфейс для точек
interface Point {
    id: number;
    x: number;
    y: number;
}

// Интерфейс для линий
interface Line {
    startX: number;
    startY: number;
    endX: number;
    endY: number;
}

// Компонент точки
function PointComponent({
                            id,
                            x,
                            y,
                            onStartLine,
                        }: {
    id: number;
    x: number;
    y: number;
    onStartLine: () => void;
}) {
    const handleMouseDown = () => {
        onStartLine();
    };

    const handleTouchStart = () => {
        onStartLine();
    };

    return (
        <div
            onMouseDown={handleMouseDown}
            onTouchStart={handleTouchStart} // Обработчик для сенсорного ввода
            className={'point'}
            style={{
                zIndex: '2',
                position: 'absolute',
                left: x + 'px',
                top: y + 'px',

            }}
        >
            <span className='id'>{id}</span>
        </div>
    )
}

function LineComponent({startX, startY, endX, endY}: Line) {
    return (
        <svg
            width="100%"
            height="100%"
            style={{position: 'absolute', top: 0, left: 0, zIndex: 1}}
        >
            <line x1={startX} y1={startY} x2={endX} y2={endY} stroke="#FFF" strokeWidth="3"/>
        </svg>
    );
}

const DrawingArea = ({
                         id,
                         points,
                         pointClassProps,
                         setLevelEnd
                     }: { id: string | undefined, points: Point[], pointClassProps: string, setLevelEnd: React.Dispatch<React.SetStateAction<boolean>> }) => {
    const [lines, setLines] = useState<Line[]>([]);
    const [isDrawing, setIsDrawing] = useState(false);
    const [startPointId, setStartPointId] = useState<number | null>(null);
    const [currentX, setCurrentX] = useState<number | null>(null);
    const [currentY, setCurrentY] = useState<number | null>(null);
    const [indexPointId, setIndexPointId] = useState<number>(1);
    let pointsMaps = points.slice();
    // const [pointsMap, setPointsMap] = useState(points.slice()); // Используйте useState для pointsMap
    const [pointsMap, setPointsMap] = useState(points.slice()); // Используйте useState для pointsMap
    const {width} = useWindowSize()
    // @ts-ignore
    const handleStartLine = (id: number) => {
        setIsDrawing(true);
        setStartPointId(id);
    };
    useEffect(() => {
        document.addEventListener('click', () => {
            handleStartLine(indexPointId - 1)

        })
    })
    const pointScale = () => {
        // Обновляем состояние pointsMap вместо изменения переменной
        const newPointsMap = pointsMaps.map((point) => {
            let newX = point.x;
            let newY = point.y;

            if (width < 374) {
                if (id === '3') {
                    newX -= 20;
                } else if (id === '6') {
                    newY -= 100;
                } else if (id === '5') {
                    newX -= 30;
                } else {
                    newX -= 70;
                    newY -= 80;
                }
            } else if (id !== '6' && id !== '3' && id !== '5') {
                newY -= 60;
                newX -= 32;
            } else if (id === '6') {
                newY -= 70;
            } else if (id === '3' || id === '5') {
                newX -= 20;
            }

            if (id === '3' || id === '5') {
                if (width > 450) {
                    newX *= 1.3;
                    newY *= 1.3;
                } else if (width > 320 && width < 376) {
                    newX *= 1.1;
                    newY *= 1.1;
                } else {
                    newX *= 1.2;
                    newY *= 1.2;
                }
            } else if (id === '6'){
                if (width > 450) {
                    newX *= 1.4;
                    newY *= 1.3;
                } else if (width > 319) {
                    newX *= 1.3;
                    newY *= 1.2;
                }
            } else {
                if (width > 450) {
                    newX *= 1.3;
                    newY *= 1.3;
                } else if (width > 375) {
                    newX *= 1.2;
                    newY *= 1.2;
                }
            }

            // if (width > 900 || (id !== '3' && id !== '5')) {
            //
            // } else if (width > 374 && (id === '3' || id === '5')) {
            //     newX *= 1.2;
            //     newY *= 1.2;
            // }

            return {...point, x: newX, y: newY};
        });

        setPointsMap(newPointsMap);

    };
    useEffect(() => {
        setLines([])
        setIndexPointId(1)
        pointScale()

    }, [id])

    const gameWrap = document.getElementById('gameWrap');


    const handleMouseMove = (event: React.MouseEvent) => {
        if (isDrawing && startPointId !== null && gameWrap && startPointId === indexPointId) {
            setCurrentX(event.clientX - gameWrap.offsetLeft);
            setCurrentY(event.clientY - gameWrap.offsetTop);
        }
    };

    const handleTouchMove = (event: React.TouchEvent) => {
        if (isDrawing && startPointId !== null && gameWrap && startPointId === indexPointId) {
            const touch = event.touches[0];

            console.log(startPointId)
            setCurrentX(touch.clientX - gameWrap.offsetLeft);
            setCurrentY(touch.clientY - gameWrap.offsetTop);
        }
    };


    const handleMouseUp = () => {
        if (isDrawing && startPointId !== null && currentX !== null && currentY !== null) {
            const xRange = Array.from({length: 61}, (_, i) => Math.ceil(pointsMap[startPointId].x) - 20 + i);
            const yRange = Array.from({length: 61}, (_, i) => Math.ceil(pointsMap[startPointId].y) - 20 + i);
            console.log(Math.ceil(currentX), xRange)
            if (xRange.includes(Math.ceil(currentX)) && yRange.includes(Math.ceil(currentY))) {
                const newLines = [...lines];
                newLines.push({
                    startX: pointsMap[startPointId - 1].x + 8,
                    startY: pointsMap[startPointId - 1].y + 8,
                    endX: pointsMap[startPointId].x + 8,
                    endY: pointsMap[startPointId].y + 8,
                });
                setLines(newLines);
                setIndexPointId(indexPointId => indexPointId + 1)
                if (!pointsMap[startPointId + 1]) {
                    setLevelEnd(true)
                }
            }
            setIsDrawing(false);
            setStartPointId(null);
            setCurrentX(null);
            setCurrentY(null);
        }
    };


    return (
        <div
            id="gameWrap"
            className={pointClassProps}
            style={{position: 'relative'}}
            onMouseMove={handleMouseMove}
            onMouseUp={handleMouseUp}
            onTouchMove={handleTouchMove}
            onTouchEnd={handleMouseUp}
        >
            {lines.map((line, index) => (
                <LineComponent
                    key={index}
                    startX={line.startX}
                    startY={line.startY}
                    endX={line.endX}
                    endY={line.endY}
                />
            ))}
            {pointsMap.map((point) => (
                <PointComponent
                    key={point.id}
                    id={point.id}
                    x={point.x}
                    y={point.y}
                    onStartLine={() => handleStartLine(point.id)}
                />
            ))}
            {isDrawing && startPointId !== null && currentX !== null && currentY !== null && (
                <LineComponent
                    startX={pointsMap[startPointId - 1].x + 6}
                    startY={pointsMap[startPointId - 1].y + 6}
                    endX={currentX}
                    endY={currentY}
                />
            )}
        </div>
    );
}
export default DrawingArea;
